/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { FieldArray, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getVendorDetail } from "./VendorHelper";
import {
  API,
  cddOptions,
  fileUpload,
  riskProfile,
  get,
  cddCustomerTypeOptions,
  customerType,
  entityType,
} from "../../config";
import {
  useBankList,
  useStateList,
  SuburbList,
  AllSuburbList,
  useCountryList,
} from "../../lib/OptionsAPI";
import {
  formatBSBNumber,
  formatedPostalCode,
  formatName,
  formatSubcontractorName,
  // getFileNameFromUrl,
  getModuleNamingBySlug,
  // MaxLimit,
} from "../../lib/Misc";
import { AddVendorSchema } from "../../lib/Validation";
// import Spin from "../../components/Spin";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import CustomLabelText from "../../components/CustomLabelText";
import { Label } from "../../components/ui/label";
import {
  Eye,
  Loader2,
  LucidePlusCircle,
  MessageSquareShareIcon,
  Plus,
  Trash2,
} from "lucide-react";
import { Input } from "../../components/ui/input";
import { CardTitle } from "../../components/ui/card";
import SearchSelect from "../../components/SearchSelect";
import PostalCodeInput from "../../components/PostalCodeInput";
import { PhoneInput } from "../../components/ui/phone-input";
import ProfileUpload from "../../components/ProfileUpload";
// import { NumericFormat } from "react-number-format";
import ReactInputMask from "react-input-mask";
import { Checkbox } from "../../components/ui/checkbox";
import SuburbSelect from "../../components/SuburbSelect";
import Spin from "../../components/Spin";
// import Dropzone from "react-dropzone";
import { Textarea } from "../../components/ui/textarea";
import { DateInputPicker } from "../../components/DateInputPicker";
// import { useTrust } from "../../lib/context/TrustContext";
// import UserSelect from "../../components/UserSelect";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { toast } from "../../components/ui/use-toast";
import moment from "moment";
import { debounce } from "lodash";
import { Switch } from "../../components/ui/switch";
import TrustSelect from "../../components/TrustSelect";
import VerificationRow from "../../components/VerificationRow";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import AddEditRiskAssessment from "../AML-CTF/Program/RiskAssessment/AddEditRiskAssessment";
import EscalatedModal from "../AML-CTF/CDD/EscalatedModal";
import RiskAssessmentDetailsPopup from "../AML-CTF/Program/RiskAssessment/RiskAssessmentDetailsPopup";
import BeneficaryRow from "../../components/BeneficaryRow";

const AddEditVendor = ({
  edit,
  setEdit,
  vendorID,
  toggleShowAddEditVendor,
  editByVendor = false,
  fetchVendors,
  org = false,
  amlCTFEnable = false,
  onlyKyc = false,
}) => {
  const { id, trust_id } = useParams();
  const [vendorData, setVendorData] = useState();

  const trustId = trust_id;
  const { organizationData } = useOrganization();

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [suburbShippingLoading, setSuburbShippingLoading] = useState(false);
  const [suburbShippingListing, setSuburbShippingListing] = useState([]);
  const [suburbShippingList, setSuburbShippingList] = useState([]);
  const [searched, setSearched] = useState(false);

  const [allSuburbLoading, setAllSuburbLoading] = useState(false);
  const [allSuburbListing, setAllSuburbListing] = useState([]);
  const [allSuburbList, setAllSuburbList] = useState([]);

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);
  const [vendorId, setVendorId] = useState(vendorID ? vendorID : id);
  const [showAssessment, setShowAssessment] = useState(false);
  const [viewAssessment, setViewAssessment] = useState(false);
  const [confirmEscalated, setConfirmEscalated] = useState(false);
  const [sectionType, setSectionType] = useState(false);

  // const formValues = useRef();
  const [isChecked, setIsChecked] = useState(false);

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);

  const [verificationMethods, setVerificationMethods] = useState([]);
  const [verificationTypes, setVerificationTypes] = useState([]);

  const toggleConfirmEscalated = () => {
    setConfirmEscalated(!confirmEscalated);
  };

  const toggleAssessment = () => {
    setShowAssessment(!showAssessment);
  };

  const toggleViewAssessment = () => {
    setViewAssessment(!viewAssessment);
  };

  const fetchVerificationMethodsTypes = async () => {
    try {
      setLoading(true);
      const { data } = await get(`${API.VERFICATION_TYPES}`);
      setVerificationMethods(data?.verification_methods);
      setVerificationTypes(data?.document_types);
      setLoading(false);
    } catch (e) {
      setVerificationMethods([]);
      setVerificationTypes([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVerificationMethodsTypes();
  }, []);

  const normalizeVerificationData = (data = {}, verificationType = {}) => {
    if (!verificationType?.fields) return data;

    const dateKeys = verificationType.fields
      .filter((f) => f.inputType === "date")
      .map((f) => f.key);

    const normalizedData = { ...data };

    dateKeys.forEach((key) => {
      if (normalizedData[key]) {
        normalizedData[key] = moment(normalizedData[key], "DD-MM-YYYY");
      }
    });

    return normalizedData;
  };

  async function fetchData() {
    try {
      setLoading(true);
      const data = await getVendorDetail(vendorId);

      setSectionType(
        data?.kyc?.cdd_customer_type
          ? `Onboarding-${data?.kyc?.cdd_customer_type === "1" ? "Ongoing" : "Initial"}`
          : "",
      );
      if (data?.same_address) {
        setIsChecked(true);
      }
      if (data?.state_id ? data?.state_id : false) {
        FetchSuburbList(data?.state_id ? data?.state_id : "", "");
        if (data?.suburb_id ? data?.suburb_id : false) {
          setSuburbList([
            data?.suburb
              ? {
                  ...data?.suburb,
                  value: data?.suburb.id,
                  label: data?.suburb.name,
                }
              : {},
          ]);
        }
      }
      if (data?.shipping_state_id ? data?.shipping_state_id : false) {
        FetchSuburbShippingList(
          data?.shipping_state_id ? data?.shipping_state_id : "",
          "",
        );
        if (data?.shipping_suburb_id ? data?.shipping_suburb_id : false) {
          setSuburbShippingList([
            data?.shipping_suburb
              ? {
                  ...data?.shipping_suburb,
                  value: data?.shipping_suburb.id,
                  label: data?.shipping_suburb.name,
                }
              : {},
          ]);
        }
      }
      data?.kyc?.verifications?.length > 0 &&
        data.kyc.verifications?.map((item) => {
          item.verified_status = item.verified_using ? true : false;
          item.date_verified = item.date_verified
            ? moment(item.date_verified, "DD-MM-YYYY")
            : null;
          item.verified_by = item?.verified_by_id ? item?.verified_by_id : "";
          item.type = item?.verification_document_type_id
            ? item?.verification_document_type_id
            : "";
          item.dynamicFields = normalizeVerificationData(
            item?.data,
            item?.verification_document_type,
          );
          return item;
        });
      setVendorData(data);
      setLoading(false);
    } catch (e) {
      setVendorData(null);
    }
  }

  // eslint-disable-next-line no-unused-vars
  const handleDownload = async (export_report_path) => {
    try {
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      toast({
        variant: "destructive",
        description: errors,
        duration: 3000,
      });
    }
  };

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorId]);

  // Submit Form
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";

    value.opening_balance = Number(
      `${value?.opening_balance}`.replace(/,/g, ""),
    );

    formData.append(
      "organization_id",
      organizationData?.organizationId ? organizationData?.organizationId : "",
    );
    if (org && value?.trust_id ? value?.trust_id : trustId) {
      formData.append(
        "trust_id",
        org && value?.trust_id ? value?.trust_id : trustId ? trustId : "",
      );
    }
    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("phone", value?.phone != null ? value?.phone : "");
    formData.append("mobile", value?.mobile != null ? value?.mobile : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : "",
    );
    formData.append(
      "business_email",
      value?.business_email ? value?.business_email : "",
    );
    formData.append("abn", value?.abn != null ? value?.abn : "");
    formData.append("code", value?.code ? value?.code : "");
    formData.append(
      "dob",
      value?.dob ? moment(value?.dob)?.format("DD-MM-YYYY") : "",
    );

    formData.append(
      "international_address",
      value.international_address ? "1" : "0",
    );

    formData.append("is_kyc", value.is_kyc ? "1" : "0");

    formData.append(
      "full_address",
      value?.full_address ? value?.full_address : "",
    );

    formData.append("country_id", value?.country_id ? value?.country_id : "");

    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append("same_address", isChecked ? 1 : 0);
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : "",
    );

    formData.append(
      "shipping_full_address",
      value?.shipping_full_address ? value?.shipping_full_address : "",
    );

    formData.append(
      "shipping_country_id",
      value?.shipping_country_id ? value?.shipping_country_id : "",
    );

    formData.append(
      "shipping_international_address",
      value.shipping_international_address ? "1" : "0",
    );

    formData.append(
      "shipping_street",
      value?.shipping_street ? value?.shipping_street : "",
    );
    formData.append(
      "shipping_state_id",
      value?.shipping_state_id ? value?.shipping_state_id : "",
    );
    formData.append(
      "shipping_suburb_id",
      value?.shipping_suburb_id ? value?.shipping_suburb_id : "",
    );
    formData.append(
      "shipping_postal_code",
      value?.shipping_postal_code ? value?.shipping_postal_code : "",
    );
    formData.append(
      "entity_type",
      value?.entity_type ? value?.entity_type : "",
    );
    value?.profile_pic &&
      formData.append(
        "profile_pic",
        value?.profile_pic ? value?.profile_pic : "",
      );
    value?.logo && formData.append("logo", value?.logo ? value?.logo : "");
    formData.append(
      "account_name",
      value?.account_name ? value?.account_name : "",
    );
    formData.append("bsb", value?.bsb ? formatBSBNumber(value?.bsb) : "");
    formData.append(
      "account_number",
      value?.account_number ? value?.account_number : "",
    );
    formData.append(
      "opening_balance",
      value?.opening_balance ? value?.opening_balance : 0,
    );
    formData.append("bank_id", value?.bank_id ? value?.bank_id : "");
    formData.append("type", value?.type ? value?.type : "");

    // formData.append("photo_id", value?.photo_id ? value?.photo_id : "");
    // formData.append("primary_id", value?.primary_id ? value?.primary_id : "");
    // formData.append(
    //   "secondary_id",
    //   value?.secondary_id ? value?.secondary_id : "",
    // );
    // formData.append(
    //   "verification_date",
    //   value?.verification_date
    //     ? moment(value?.verification_date)?.format("DD-MM-YYYY")
    //     : "",
    // );
    // formData.append(
    //   "verified_by",
    //   value?.verified_by ? value?.verified_by : "",
    // );
    // formData.append("method", value?.method ? value?.method : "");
    if (value.is_kyc) {
      formData.append("risk", value?.risk ? value?.risk : "");
      formData.append(
        "cdd_customer_type",
        value?.cdd_customer_type ? value?.cdd_customer_type : "",
      );

      formData.append("cdd", value?.cdd ? value?.cdd : "");
      formData.append("notes", value?.notes ? value?.notes : "");
      formData.append("ntf_note", value?.ntf_note ? value?.ntf_note : "");
      formData.append(
        "risk_assessment_id",
        value?.risk_assessment_id ? value?.risk_assessment_id : "",
      );

      formData.append(
        "compliance_manager_id",
        value?.compliance_manager_id ? value?.compliance_manager_id : "",
      );

      formData.append("reason", value?.reason ? value?.reason : "");

      if (value.beneficiaries?.length) {
        value.beneficiaries.forEach((row, index) => {
          if (row.id) {
            formData.append(`beneficiaries[${index}][id]`, row.id ?? "");
          }
          formData.append(`beneficiaries[${index}][name]`, row.name ?? "");
          formData.append(
            `beneficiaries[${index}][percentage]`,
            row.percentage ? row.percentage?.toString()?.replace("%", "") : "",
          );
        });
      }

      if (value.verifications?.length) {
        value.verifications.forEach((row, index) => {
          // ▪ METHOD
          formData.append(`verifications[${index}][method]`, row.method ?? "");

          // ▪ METHOD = 1 OR 2 → FILE
          // if ((row.method === 1 || row.method === 2) && row.file) {
          //   formData.append(
          //     `verifications[${index}][file]`,
          //     row.file.file // AntD upload stores file under .file
          //   );
          // }

          // ▪ METHOD = 3 → TYPE
          if (row.id) {
            formData.append(`verifications[${index}][id]`, row.id ?? "");
          }

          formData.append(`verifications[${index}][type]`, row.type ?? "");

          formData.append(
            `verifications[${index}][date_verified]`,
            row.date_verified
              ? moment(row.date_verified).format("DD-MM-YYYY")
              : "",
          );

          formData.append(
            `verifications[${index}][document_number]`,
            row.document_number ?? "",
          );

          formData.append(
            `verifications[${index}][verified_by]`,
            row.verified_by ?? "",
          );
          formData.append(
            `verifications[${index}][verified]`,
            row.verified ?? "",
          );

          formData.append(
            `verifications[${index}][key]`,
            verificationTypes?.find((item) => item.id === row?.type)?.key &&
              row?.type
              ? verificationTypes?.find((item) => item.id === row?.type)?.key
              : "",
          );

          if (row.method === 3) {
            // ▪ Dynamic Fields
            if (row.dynamicFields) {
              Object.keys(row.dynamicFields).forEach((key) => {
                let value = row.dynamicFields[key];

                // If value is moment
                if (moment.isMoment(value)) {
                  value = value.format("DD-MM-YYYY");
                }

                // If value is JS Date
                else if (value instanceof Date) {
                  value = moment(value).format("DD-MM-YYYY");
                }

                formData.append(
                  `verifications[${index}][fields][${key}]`,
                  value ?? "",
                );
              });
            }
          }
        });
      }
    }

    value.joint_accounts.forEach((item, index) => {
      if (item.last_name) {
        formData.append(`joint_accounts[${index}][id]`, item.id || "");
        formData.append(
          `joint_accounts[${index}][first_name]`,
          item.first_name || "",
        );
        formData.append(
          `joint_accounts[${index}][last_name]`,
          item.last_name || "",
        );
        formData.append(
          `joint_accounts[${index}][dob]`,
          item?.dob ? moment(item?.dob)?.format("DD-MM-YYYY") : "",
        );

        formData.append(
          `joint_accounts[${index}][international_address]`,
          item.international_address ? "1" : "0",
        );

        formData.append(
          `joint_accounts[${index}][full_address]`,
          item.full_address || "",
        );

        formData.append(
          `joint_accounts[${index}][country_id]`,
          item.country_id || "",
        );

        formData.append(`joint_accounts[${index}][street]`, item.street || "");
        formData.append(
          `joint_accounts[${index}][state_id]`,
          item.state_id || "",
        );
        formData.append(
          `joint_accounts[${index}][suburb_id]`,
          item.suburb_id || "",
        );
        formData.append(
          `joint_accounts[${index}][postal_code]`,
          item.postal_code || "",
        );

        formData.append(
          `joint_accounts[${index}][account_name]`,
          item.account_name || "",
        );

        formData.append(
          `joint_accounts[${index}][bsb]`,
          item?.bsb ? formatBSBNumber(item?.bsb) : "",
        );

        formData.append(
          `joint_accounts[${index}][account_number]`,
          item.account_number || "",
        );
        formData.append(
          `joint_accounts[${index}][bank_id]`,
          item.bank_id || "",
        );
      }
    });

    if (vendorId) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.VENDOR_ADD}${vendorId ? `/${vendorId}` : ""}`,
        formData,
      );

      if (!edit && data && amlCTFEnable) {
        setVendorId(data?.data?.id);
        setEdit(true);
      }
      setLoading(false);
      if (data) {
        editByVendor &&
          localStorage.setItem(
            "BusinessName",
            value?.business_name ? value?.business_name : "",
          );
        (edit || !setEdit) && amlCTFEnable && toggleShowAddEditVendor();
        fetchVendors && fetchVendors();
      }
      return data?.data;
    } catch (error) {
      setVendorData(value);
      setLoading(false);
    }
  };

  // Country
  // eslint-disable-next-line no-unused-vars
  const { countryLoading, countryList = [] } = useCountryList();
  const countryListing = countryList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const country = countryListing?.find(
    (item) =>
      item?.value === (vendorData?.country_id ? vendorData?.country_id : ""),
  )?.value;

  // ShippingCountry
  const shippingCountryListing = countryList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const shippingCountry = shippingCountryListing?.find(
    (item) =>
      item?.value ===
      (vendorData?.shipping_country_id ? vendorData?.shipping_country_id : ""),
  )?.value;

  // State
  // eslint-disable-next-line no-unused-vars
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) =>
      item?.value === (vendorData?.state_id ? vendorData?.state_id : ""),
  )?.value;

  // ShippingState
  const shippingStateListing = stateList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const shippingState = shippingStateListing?.find(
    (item) =>
      item?.value ===
      (vendorData?.shipping_state_id ? vendorData?.shipping_state_id : ""),
  )?.value;

  // eslint-disable-next-line no-unused-vars
  const { bankLoading, bankList = [] } = useBankList();
  const bankListing = bankList ? bankList : [];
  const projectBank = bankListing?.find(
    (item) => item?.value === vendorData?.bank_id,
  )?.value;

  const toggleChecked = (values, setFieldValue) => {
    setIsChecked(!isChecked);
    if (isChecked === false) {
      setFieldValue(
        "shipping_international_address",
        values?.international_address,
      );
      if (values?.international_address) {
        setFieldValue("shipping_full_address", values?.full_address);
        setFieldValue("shipping_country_id", values?.country_id);
      } else {
        setFieldValue("shipping_street", values?.street);
        setFieldValue("shipping_state_id", values?.state_id);
        setFieldValue("shipping_suburb_id", values?.suburb_id);
        setFieldValue("shipping_postal_code", values?.postal_code);
        setSuburbShippingListing([
          suburbListing?.find((item) => item.value === values?.suburb_id),
        ]);
      }
    } else {
      setFieldValue("shipping_international_address", "");
      setFieldValue("shipping_full_address", "");
      setFieldValue("shipping_country_id", "");
      setFieldValue("shipping_street", "");
      setFieldValue("shipping_state_id", "");
      setFieldValue("shipping_suburb_id", "");
      //   dispatch(shippingSuburbsList("", ""));
      setSuburbShippingListing([]);
      setSuburbShippingList([]);
      setFieldValue("shipping_postal_code", "");
    }
  };

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  const FetchSuburbShippingList = async (state_id) => {
    await SuburbList(
      state_id,
      1,
      setSuburbShippingLoading,
      setSuburbShippingList,
      true,
    );
  };

  useEffect(() => {
    if (suburbShippingList) {
      let suburbShippingTempListing = suburbShippingList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbShippingListing(suburbShippingTempListing || []);
    } else {
      setSuburbShippingListing([]);
    }
  }, [suburbShippingList]);

  const FetchAllSuburbList = async (search = "") => {
    await AllSuburbList(
      "",
      1,
      setAllSuburbLoading,
      setAllSuburbList,
      false,
      search,
    );
  };

  useEffect(() => {
    if (!searched) {
      FetchAllSuburbList();
    }
  }, [searched]);

  useEffect(() => {
    if (allSuburbList) {
      let allSuburbTempListing = allSuburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setAllSuburbListing(allSuburbTempListing || []);
    } else {
      setAllSuburbListing([]);
    }
  }, [allSuburbList]);

  const debouncedSave = useCallback(
    debounce((nextValue) => {
      FetchAllSuburbList(nextValue);
    }, 300),
    [],
  );

  const handleSearchAllSuburb = (value) => {
    if (value) {
      debouncedSave(value);
    }
  };

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${
          item?.business_name
            ? item?.business_name
            : item?.first_name
              ? item?.first_name + " " + item?.last_name
              : item?.last_name
        } ${item?.account_number ? `(${item?.account_number})` : ""}`,
      }));
      let finalList = trustTempListing?.filter(
        (item) => item?.id !== trustId && item?.id !== "new",
      );
      setTrustListing(finalList || []);
    } else {
      setTrustListing([]);
    }
  }, [trustList, trustId]);

  return (
    <Formik
      initialValues={{
        trust_id: vendorData?.trust_id
          ? vendorData?.trust_id
          : trustId
            ? trustId
            : "",
        profile_pic: vendorData?.profile_pic ? vendorData?.profile_pic : "",
        logo: vendorData?.logo ? vendorData?.logo : "",
        first_name: vendorData?.first_name ? vendorData?.first_name : "",
        last_name: vendorData?.last_name ? vendorData?.last_name : "",
        phone: vendorData?.phone
          ? vendorData?.phone[0] === "+"
            ? vendorData?.phone
            : `+${vendorData?.phone}`
          : "",
        mobile: vendorData?.mobile
          ? vendorData?.mobile[0] === "+"
            ? vendorData?.mobile
            : `+${vendorData?.mobile}`
          : "",
        email: vendorData?.email ? vendorData?.email : "",
        dob: vendorData?.dob ? moment(vendorData?.dob, "DD-MM-YYYY") : "",
        business_name: vendorData?.business_name
          ? vendorData?.business_name
          : vendorData?.client?.business_name,
        business_email: vendorData?.business_email
          ? vendorData?.business_email
          : "",
        abn: vendorData?.abn ? vendorData?.abn : "",
        code: vendorData?.code ? vendorData?.code : "",
        type: vendorData?.type ? vendorData?.type : "",
        entity_type: vendorData?.entity_type ? vendorData?.entity_type : "",
        international_address:
          vendorData?.international_address == "1" ? true : false,
        full_address: vendorData?.full_address ? vendorData?.full_address : "",
        country_id: country,

        street: vendorData?.street ? vendorData?.street : "",
        state_id: state,
        suburb_id: vendorData?.suburb_id,
        postal_code: vendorData?.postal_code
          ? formatedPostalCode(vendorData?.postal_code)
          : "",
        shipping_international_address:
          vendorData?.shipping_international_address == "1" ? true : false,

        shipping_full_address: vendorData?.shipping_full_address
          ? vendorData?.shipping_full_address
          : "",
        shipping_country_id: shippingCountry,
        shipping_street: vendorData?.shipping_street
          ? vendorData?.shipping_street
          : "",
        shipping_state_id: shippingState,
        shipping_suburb_id: vendorData?.shipping_suburb_id
          ? vendorData?.shipping_suburb_id
          : "",
        shipping_postal_code: vendorData?.shipping_postal_code
          ? formatedPostalCode(vendorData?.shipping_postal_code)
          : "",
        account_name: vendorData?.account_name ? vendorData?.account_name : "",
        bsb: vendorData?.bsb ? vendorData?.bsb : "",
        account_number: vendorData?.account_number
          ? vendorData?.account_number
          : "",
        opening_balance: vendorData?.opening_balance
          ? vendorData?.opening_balance
          : 0,
        bank_id: projectBank ? projectBank : "",
        // photo_id: vendorData?.kyc?.photo_id ? vendorData?.kyc?.photo_id : "",
        // primary_id: vendorData?.kyc?.primary_id
        //   ? vendorData?.kyc?.primary_id
        //   : null,
        // secondary_id: vendorData?.kyc?.secondary_id
        //   ? vendorData?.kyc?.secondary_id
        //   : null,
        // verification_date: vendorData?.kyc?.verification_date
        //   ? moment(vendorData?.kyc?.verification_date, "DD-MM-YYYY")
        //   : "",
        // verified_by: vendorData?.kyc?.verified_by
        //   ? vendorData?.kyc?.verified_by
        //   : "",
        // method: vendorData?.kyc?.method ? vendorData?.kyc?.method : "",
        // risk: vendorData?.kyc?.risk ? vendorData?.kyc?.risk : "",
        // cdd: vendorData?.kyc?.cdd ? vendorData?.kyc?.cdd : "",
        // notes: vendorData?.kyc?.notes ? vendorData?.kyc?.notes : "",
        joint_accounts: vendorData?.joint_accounts
          ? vendorData?.joint_accounts
          : [],

        cdd_customer_type: vendorData?.kyc?.cdd_customer_type
          ? vendorData?.kyc?.cdd_customer_type
          : "",
        cdd: vendorData?.kyc?.cdd ? vendorData?.kyc?.cdd : "",
        risk: vendorData?.kyc?.risk ? vendorData?.kyc?.risk : "",
        notes: vendorData?.kyc?.notes ? vendorData?.kyc?.notes : "",
        is_kyc: vendorData?.is_kyc == "1" || onlyKyc ? true : false,
        beneficiaries: vendorData?.beneficiaries
          ? vendorData?.beneficiaries
          : [],
        verifications: vendorData?.kyc?.verifications
          ? vendorData?.kyc?.verifications
          : [
              {
                method: "",
                type: "",
                document_number: "",
                date_verified: "",
                verified_by: "",
                verified: "",
                dynamicFields: {},
              },
            ],

        risk_assessment_id: vendorData?.kyc?.risk_assessment?.id
          ? vendorData?.kyc?.risk_assessment?.id
          : "",

        compliance_manager_id: vendorData?.escalate?.compliance_manager_id
          ? vendorData?.escalate?.compliance_manager_id
          : "",
        compliance_manager_name: vendorData?.escalate?.compliance_manager_name
          ? vendorData?.escalate?.compliance_manager_name
          : "",
        reason: vendorData?.escalate?.reason
          ? vendorData?.escalate?.reason
          : "",
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddVendorSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-hidden overflow-y-auto max-h-[80vh] p-4 border rounded-lg">
              {!onlyKyc && (
                <>
                  <div>
                    <ProfileUpload
                      path={values?.profile_pic}
                      pathData={values?.business_name?.charAt(0)}
                      setFieldValue={setFieldValue}
                      keyName={"profile_pic"}
                    />
                  </div>
                  <div className="grid gap-4">
                    <CardTitle className="text-md mt-5">
                      Personal Details
                    </CardTitle>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4">
                      {org && (
                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="trust_id">
                              <CustomLabelText
                                required={false}
                                labelText="Trust"
                                errorField={errors?.bank_id}
                              />
                            </Label>
                            <div className="relative mt-2">
                              <TrustSelect
                                orgId={organizationData?.organizationId}
                                frameworkData={trustListing} // List of vendors
                                optionType="Trust"
                                handleBlur={handleBlur}
                                handleSelect={(e) => {
                                  setFieldValue("trust_id", e);
                                }}
                                name="trust_id"
                                disabled={
                                  organizationData?.organizationId
                                    ? false
                                    : true
                                }
                                initialValue={
                                  values?.trust_id ? values?.trust_id : ""
                                }
                                setTrustList={setTrustList} // Update vendor list as new data loads
                                setTrustLoading={setTrustLoading} // Control loading state
                                onClear={() => {
                                  setFieldValue("trust_id", "");
                                }}
                                loading={trustLoading}
                              />
                              {bankLoading && (
                                <span className="absolute top-2 right-2 animate-spin">
                                  <Loader2 width={20} height={20} />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {/* <div className="grid md:grid-cols-2 gap-4"> */}
                      <div className="grid gap-2">
                        <Label htmlFor="first_name">
                          <CustomLabelText
                            required={false}
                            labelText="First Name"
                            errorField={errors?.first_name}
                          />
                        </Label>
                        <Input
                          id="first_name"
                          type="text"
                          name="first_name"
                          value={values?.first_name ? values?.first_name : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          className={
                            errors?.first_name &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      <div className="grid gap-2">
                        <Label htmlFor="last_name">
                          <CustomLabelText
                            required={true}
                            labelText="Last Name"
                            errorField={errors?.last_name}
                          />
                        </Label>
                        <Input
                          id="last_name"
                          type="text"
                          name="last_name"
                          value={values?.last_name ? values?.last_name : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          className={
                            errors?.last_name &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      {/* </div> */}
                      {/* <div className="grid md:grid-cols-2 gap-4"> */}
                      <div className="grid gap-2">
                        <Label htmlFor="phone">
                          <CustomLabelText
                            required={false}
                            labelText="Phone"
                            errorField={errors?.phone}
                          />
                        </Label>
                        <PhoneInput
                          onChange={(e) => {
                            setFieldValue("phone", e);
                          }}
                          value={values?.phone}
                          defaultValue={"+61"}
                          defaultCountry={"AU"}
                          minLength={15}
                          maxLength={15}
                          onBlur={handleBlur}
                          className={
                            errors?.phone &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      <div className="grid gap-2">
                        <Label htmlFor="mobile">
                          <CustomLabelText
                            required={false}
                            labelText="Mobile No."
                            errorField={errors?.mobile}
                          />
                        </Label>
                        <PhoneInput
                          onChange={(e) => {
                            setFieldValue("mobile", e);
                          }}
                          value={values?.mobile}
                          defaultValue={"+61"}
                          defaultCountry={"AU"}
                          minLength={15}
                          maxLength={15}
                          onBlur={handleBlur}
                          className={
                            errors?.mobile &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      {/* </div> */}
                      {/* <div className="grid md:grid-cols-2 gap-4"> */}
                      <div className="grid gap-2">
                        <Label htmlFor="email">
                          <CustomLabelText
                            required={true}
                            labelText="Email"
                            errorField={errors?.email}
                          />
                        </Label>
                        <Input
                          id="email"
                          type="email"
                          placeholder="m@example.com"
                          required
                          autoComplete="off"
                          name="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.email}
                          className={
                            errors?.email &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      <div className="grid gap-2">
                        <Label htmlFor="business_name">
                          <CustomLabelText
                            required={false}
                            labelText="Business Name"
                            errorField={errors?.business_name}
                          />
                        </Label>
                        <Input
                          id="business_name"
                          type="text"
                          name="business_name"
                          value={
                            values?.business_name ? values?.business_name : ""
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          className={
                            errors?.business_name &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      {/* </div> */}
                      {/* <div className="grid md:grid-cols-2 gap-4"> */}
                      <div className="grid gap-2">
                        <Label htmlFor="business_email">
                          <CustomLabelText
                            required={false}
                            labelText="Business Email"
                            errorField={errors?.business_email}
                          />
                        </Label>
                        <Input
                          id="business_email"
                          type="business_email"
                          placeholder="m@example.com"
                          required
                          autoComplete="off"
                          name="business_email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.business_email}
                          className={
                            errors?.business_email &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      <div className="grid gap-2">
                        <Label htmlFor="abn">
                          <CustomLabelText
                            required={
                              values?.entity_type === "1" ? true : false
                            }
                            labelText="ABN"
                            errorField={errors?.abn}
                          />
                        </Label>
                        <ReactInputMask
                          id="abn"
                          type="text"
                          name="abn"
                          value={values?.abn ? values?.abn : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          mask="99 999 999 999"
                          maskChar={null}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          className={
                            errors?.abn
                              ? `${cn(
                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                )} focus-visible:ring-red-500 border-red-500`
                              : cn(
                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                )
                          }
                        />
                      </div>
                      {/* </div> */}
                      {/* <div className="grid md:grid-cols-2 gap-4"> */}
                      <div className="grid gap-2">
                        <Label htmlFor="code">
                          <CustomLabelText
                            required={false}
                            labelText="Code"
                            errorField={errors?.code}
                          />
                        </Label>
                        <Input
                          id="code"
                          type="text"
                          name="code"
                          value={values?.code ? values?.code : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          className={
                            errors?.code &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                        />
                      </div>
                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="verification_date">
                            <CustomLabelText
                              labelText="Date Of Birth"
                              errorField={errors?.dob}
                            />
                          </Label>
                          <div className="relative mt-2">
                            <DateInputPicker
                              date={values?.dob ? values?.dob : ""}
                              onSelect={(e) => {
                                setFieldValue("dob", e);
                              }}
                              inputClassName="w-full"
                              className={""}
                              disabledDate={{ after: new Date() }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid gap-2">
                        <Label htmlFor="type">
                          <CustomLabelText
                            required={true}
                            labelText="Client Type"
                            errorField={errors?.type}
                          />
                        </Label>
                        <div className="relative">
                          <SearchSelect
                            frameworks={customerType}
                            optionType={"Client Type"}
                            handleSelect={(e) => {
                              setFieldValue("type", e);
                              setFieldValue("beneficiaries", []);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.type &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.type}
                          />
                        </div>
                      </div>

                      {values?.type === "2" && (
                        <div className="grid gap-2">
                          <Label htmlFor="entity_type">
                            <CustomLabelText
                              required={true}
                              labelText="Entity Type"
                              errorField={errors?.entity_type}
                            />
                          </Label>
                          <div className="relative">
                            <SearchSelect
                              frameworks={entityType}
                              optionType={"Entity Type"}
                              handleSelect={(e) => {
                                setFieldValue("entity_type", e);
                              }}
                              handleBlur={handleBlur}
                              className={
                                errors?.entity_type &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                              disabled={false}
                              initialValue={values?.entity_type}
                            />
                          </div>
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                  </div>
                  <div className="grid gap-4 pt-4">
                    <CardTitle className="text-md">
                      <div className="flex w-full items-center justify-between">
                        <div>Postal Address</div>
                        <div className="flex gap-2 items-center">
                          <Label>
                            <CustomLabelText
                              labelText="International Address"
                              errorField={errors?.international_address}
                            />
                          </Label>
                          <Switch
                            name="international_address"
                            checked={values?.international_address}
                            onCheckedChange={(checked) =>
                              setFieldValue("international_address", checked)
                            }
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </CardTitle>
                    {values?.international_address ? (
                      <div className="grid md:grid-cols-4 grid-cols-1 gap-4">
                        <div className="grid gap-1 col-span-3">
                          <Label htmlFor="full_address">
                            <CustomLabelText
                              required={false}
                              labelText="Full Address"
                              errorField={errors?.full_address}
                            />
                          </Label>
                          <Input
                            id="full_address"
                            placeholder="Enter Address"
                            required
                            name="full_address"
                            onChange={(e) => {
                              setFieldValue("full_address", e?.target?.value);
                              if (isChecked) {
                                setFieldValue(
                                  "shipping_full_address",
                                  e?.target?.value,
                                );
                              }
                            }}
                            onBlur={handleBlur}
                            value={values?.full_address}
                            className={
                              errors?.full_address &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="country_id">
                              <CustomLabelText
                                required={false}
                                labelText="Country"
                                errorField={errors?.country_id}
                              />
                            </Label>
                            <div className="relative mt-2">
                              <SearchSelect
                                frameworks={countryListing}
                                itemsPerPage={300}
                                optionType={"Country"}
                                clearable={true}
                                onClear={() => {
                                  setFieldValue("country_id", "");
                                  if (isChecked) {
                                    setFieldValue("shipping_country_id", "");
                                  }
                                }}
                                handleSelect={(e) => {
                                  setFieldValue("country_id", e);
                                  if (isChecked) {
                                    setFieldValue("shipping_country_id", e);
                                  }
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.country_id &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                disabled={false}
                                initialValue={values?.country_id}
                              />
                              {countryLoading && (
                                <span className="absolute top-2 right-2 animate-spin">
                                  <Loader2 width={20} height={20} />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                        <div className="grid md:grid-cols-2 gap-4">
                          <div className="grid gap-1">
                            <Label htmlFor="street">
                              <CustomLabelText
                                required={false}
                                labelText="Street Address"
                                errorField={errors?.street}
                              />
                            </Label>
                            <Input
                              id="street"
                              placeholder="Enter Street"
                              required
                              name="street"
                              onChange={(e) => {
                                setFieldValue("street", e?.target?.value);
                                if (isChecked) {
                                  setFieldValue(
                                    "shipping_street",
                                    e?.target?.value,
                                  );
                                }
                              }}
                              onBlur={handleBlur}
                              value={values?.street}
                              className={
                                errors?.street &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="state_id">
                                <CustomLabelText
                                  required={false}
                                  labelText="State"
                                  errorField={errors?.state_id}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SearchSelect
                                  frameworks={stateListing}
                                  optionType={"State"}
                                  clearable={true}
                                  onClear={() => {
                                    setFieldValue("state_id", "");
                                    setFieldValue("suburb_id", "");
                                    setSuburbList([]);

                                    if (isChecked) {
                                      setFieldValue("shipping_state_id", "");
                                      setFieldValue("shipping_suburb_id", "");
                                      setSuburbShippingList([]);
                                    }
                                  }}
                                  handleSelect={(e) => {
                                    setFieldValue("state_id", e);
                                    setFieldValue("suburb_id", "");
                                    setSuburbList([]);
                                    FetchSuburbList(e);
                                    if (isChecked) {
                                      setFieldValue("shipping_state_id", e);
                                      setFieldValue("shipping_suburb_id", "");
                                      setSuburbShippingList([]);
                                    }
                                  }}
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.state_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={false}
                                  initialValue={values?.state_id}
                                />
                                {stateLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="suburb_id">
                                <CustomLabelText
                                  required={false}
                                  labelText="Suburb"
                                  errorField={errors?.suburb_id}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SuburbSelect
                                  state_id={values?.state_id} // Pass the selected state ID
                                  frameworkData={suburbListing} // List of suburbs
                                  loading={suburbLoading}
                                  onClear={() => {
                                    setFieldValue("suburb_id", "");
                                    if (isChecked) {
                                      setFieldValue("shipping_suburb_id", "");
                                    }
                                  }}
                                  optionType="Suburb"
                                  handleSelect={(e) => {
                                    setFieldValue("suburb_id", e);
                                    if (isChecked) {
                                      setFieldValue("shipping_suburb_id", e);
                                    }
                                  }}
                                  name="suburb_id"
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.suburb_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={values?.state_id ? false : true}
                                  initialValue={values?.suburb_id}
                                  setSuburbList={setSuburbList} // Update suburb list as new data loads
                                  setSuburbLoading={setSuburbLoading} // Control loading state
                                />
                                {suburbLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="grid gap-2">
                            <Label htmlFor="postal_code">
                              <CustomLabelText
                                required={false}
                                labelText="Postal Code"
                                errorField={errors?.postal_code}
                              />
                            </Label>
                            <PostalCodeInput
                              id="postal_code"
                              placeholder="Enter Postal Code"
                              required={false}
                              name="postal_code"
                              handleChange={(e) => {
                                setFieldValue("postal_code", e);
                                if (isChecked) {
                                  setFieldValue("shipping_postal_code", e);
                                }
                              }}
                              handleBlur={handleBlur}
                              className="justify-start"
                              inputClassName={
                                errors?.postal_code &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                              value={
                                values?.postal_code ? values?.postal_code : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <hr className="hr-content mt-4" />

                  <div className="flex items-center space-x-2 mt-4">
                    <Checkbox
                      id="terms"
                      checked={isChecked}
                      name="same_address"
                      onClick={() => toggleChecked(values, setFieldValue)}
                      disabled={
                        values?.international_address
                          ? !values?.full_address || !values?.country_id
                          : !values?.street ||
                            !values?.state_id ||
                            !values?.postal_code ||
                            !values?.suburb_id
                      }
                    />
                    <label
                      htmlFor="terms"
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      Same as Address
                    </label>
                  </div>
                  <div className="grid gap-4 pt-4">
                    <CardTitle className="text-md">
                      <div className="flex w-full items-center justify-between">
                        <div>Street Address</div>
                        <div className="flex gap-2 items-center">
                          <Label>
                            <CustomLabelText
                              labelText="International Address"
                              errorField={
                                errors?.shipping_international_address
                              }
                            />
                          </Label>
                          <Switch
                            name="shipping_international_address"
                            checked={values?.shipping_international_address}
                            onCheckedChange={(checked) =>
                              setFieldValue(
                                "shipping_international_address",
                                checked,
                              )
                            }
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </CardTitle>
                    {values?.shipping_international_address ? (
                      <div className="grid md:grid-cols-4 grid-cols-1 gap-4">
                        <div className="grid gap-1 col-span-3">
                          <Label htmlFor="shipping_full_address">
                            <CustomLabelText
                              required={false}
                              labelText="Full Address"
                              errorField={errors?.shipping_full_address}
                            />
                          </Label>
                          <Input
                            id="shipping_full_address"
                            placeholder="Enter Address"
                            required
                            name="shipping_full_address"
                            onChange={(e) => {
                              setFieldValue(
                                "shipping_full_address",
                                e?.target?.value,
                              );
                            }}
                            disabled={isChecked}
                            onBlur={handleBlur}
                            value={values?.shipping_full_address}
                            className={
                              errors?.shipping_full_address &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="shipping_country_id">
                              <CustomLabelText
                                required={false}
                                labelText="Country"
                                errorField={errors?.shipping_country_id}
                              />
                            </Label>
                            <div className="relative mt-2">
                              <SearchSelect
                                frameworks={countryListing}
                                itemsPerPage={300}
                                optionType={"Country"}
                                clearable={true}
                                onClear={() => {
                                  setFieldValue("shipping_country_id", "");
                                }}
                                handleSelect={(e) => {
                                  setFieldValue("shipping_country_id", e);
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.shipping_country_id &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                disabled={isChecked}
                                initialValue={values?.shipping_country_id}
                              />
                              {countryLoading && (
                                <span className="absolute top-2 right-2 animate-spin">
                                  <Loader2 width={20} height={20} />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                        <div className="grid md:grid-cols-2 gap-4">
                          <div className="grid gap-1">
                            <Label htmlFor="shipping_street">
                              <CustomLabelText
                                required={false}
                                labelText="Street Address"
                                errorField={errors?.shipping_street}
                              />
                            </Label>
                            <Input
                              id="shipping_street"
                              placeholder="Enter Street"
                              required
                              name="shipping_street"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.shipping_street}
                              disabled={isChecked}
                              className={
                                errors?.shipping_street &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="shipping_state_id">
                                <CustomLabelText
                                  required={false}
                                  labelText="State"
                                  errorField={errors?.shipping_state_id}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SearchSelect
                                  frameworks={stateListing}
                                  optionType={"State"}
                                  clearable={true}
                                  onClear={() => {
                                    setFieldValue("shipping_state_id", "");
                                    setFieldValue("shipping_suburb_id", "");
                                    setSuburbShippingList([]);
                                  }}
                                  handleSelect={(e) => {
                                    setFieldValue("shipping_state_id", e);
                                    FetchSuburbShippingList(e);
                                    setFieldValue("shipping_suburb_id", "");
                                    setSuburbShippingList([]);
                                  }}
                                  handleBlur={handleBlur}
                                  disabled={isChecked}
                                  className={
                                    errors?.shipping_state_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  // disabled={false}
                                  initialValue={values?.shipping_state_id}
                                />
                                {stateLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="shipping_suburb_id">
                                <CustomLabelText
                                  required={false}
                                  labelText="Suburb"
                                  errorField={errors?.shipping_suburb_id}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SuburbSelect
                                  state_id={values?.shipping_state_id} // Pass the selected state ID
                                  frameworkData={suburbShippingListing} // List of suburbs
                                  loading={suburbLoading}
                                  onClear={() => {
                                    setFieldValue("shipping_suburb_id", "");
                                    if (isChecked) {
                                      setFieldValue("shipping_suburb_id", "");
                                    }
                                  }}
                                  optionType="Suburb"
                                  handleSelect={(e) => {
                                    setFieldValue("shipping_suburb_id", e);
                                    if (isChecked) {
                                      setFieldValue("shipping_suburb_id", e);
                                    }
                                  }}
                                  name="shipping_suburb_id"
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.shipping_suburb_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={
                                    isChecked ||
                                    (values?.shipping_state_id ? false : true)
                                  }
                                  initialValue={values?.shipping_suburb_id}
                                  setSuburbList={setSuburbShippingList} // Update suburb list as new data loads
                                  setSuburbLoading={setSuburbShippingLoading} // Control loading state
                                />
                                {suburbShippingLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="grid gap-2">
                            <Label htmlFor="shipping_postal_code">
                              <CustomLabelText
                                required={false}
                                labelText="Postal Code"
                                errorField={errors?.shipping_postal_code}
                              />
                            </Label>
                            <PostalCodeInput
                              id="shipping_postal_code"
                              placeholder="Enter Postal Code"
                              required={false}
                              name="shipping_postal_code"
                              handleChange={(e) => {
                                setFieldValue("shipping_postal_code", e);
                              }}
                              handleBlur={handleBlur}
                              className="justify-start"
                              disabled={isChecked}
                              inputClassName={
                                errors?.shipping_postal_code &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                              value={
                                values?.shipping_postal_code
                                  ? values?.shipping_postal_code
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="grid gap-4 pt-4">
                    <CardTitle className="text-md">
                      Bank Account Details (
                      {getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}{" "}
                      / Conveyancer / Solicitor Bank Account){" "}
                    </CardTitle>
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="bank_id">
                              <CustomLabelText
                                required={false}
                                labelText="Bank Name"
                                errorField={errors?.bank_id}
                              />
                            </Label>
                            <div className="relative mt-2">
                              <SearchSelect
                                frameworks={bankListing}
                                optionType={"Bank"}
                                handleSelect={(e) => {
                                  setFieldValue("bank_id", e);
                                }}
                                clearable={true}
                                onClear={() => {
                                  setFieldValue("bank_id", "");
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.bank_id &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                disabled={false}
                                initialValue={values?.bank_id}
                              />
                              {bankLoading && (
                                <span className="absolute top-2 right-2 animate-spin">
                                  <Loader2 width={20} height={20} />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="grid gap-2">
                          <Label htmlFor="account_name">
                            <CustomLabelText
                              required={false}
                              labelText="Bank Account Name"
                              errorField={errors?.account_name}
                            />
                          </Label>
                          <Input
                            type="text"
                            name="account_name"
                            value={
                              values?.account_name ? values?.account_name : ""
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            autoComplete="off"
                            onKeyPress={(e) => {
                              e.which === 13 && e.preventDefault();
                            }}
                            className={
                              errors?.account_name &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                      </div>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="grid gap-2">
                          <Label htmlFor="bsb">
                            <CustomLabelText
                              required={false}
                              labelText="BSB"
                              errorField={errors?.bsb}
                            />
                          </Label>
                          <ReactInputMask
                            id="bsb"
                            type="text"
                            name="bsb"
                            value={values?.bsb ? values?.bsb : ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            mask="999-999"
                            maskChar={null}
                            autoComplete="off"
                            onKeyPress={(e) => {
                              e.which === 13 && e.preventDefault();
                            }}
                            className={
                              errors?.bsb
                                ? `${cn(
                                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                  )} focus-visible:ring-red-500 border-red-500`
                                : cn(
                                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                  )
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="account_number">
                            <CustomLabelText
                              required={false}
                              labelText="Account Number"
                              errorField={errors?.account_number}
                            />
                          </Label>
                          <ReactInputMask
                            id="account_number"
                            type="text"
                            name="account_number"
                            value={
                              values?.account_number
                                ? values?.account_number
                                : ""
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            mask="999999999"
                            maskChar={null}
                            autoComplete="off"
                            onKeyPress={(e) => {
                              e.which === 13 && e.preventDefault();
                            }}
                            className={
                              errors?.account_number
                                ? `${cn(
                                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                  )} focus-visible:ring-red-500 border-red-500`
                                : cn(
                                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                  )
                            }
                          />
                        </div>
                      </div>
                      <div className="grid md:grid-cols-2 gap-4 items-baseline">
                        {/* <div className="grid gap-2">
                      <Label
                        htmlFor="apca_id"
                        className="flex items-center gap-2"
                      >
                        <div className="apca-info">
                          <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                              <Button
                                size="icon"
                                className="rounded-full h-4 w-4"
                              >
                                <LucideInfo className="h-4 w-4" />
                                <span className="sr-only">APCA ID Info</span>
                              </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="start">
                              <DropdownMenuItem
                                onClick={() => {
                                  setFieldValue(`apca_id`, "000000");
                                }}
                              >
                                ANZ - 000000
                              </DropdownMenuItem>
                              <DropdownMenuItem
                                onClick={() => {
                                  setFieldValue(`apca_id`, "000000");
                                }}
                              >
                                Westpac - 000000
                              </DropdownMenuItem>
                              <DropdownMenuItem
                                onClick={() => {
                                  setFieldValue(`apca_id`, "301500");
                                }}
                              >
                                CBA - 301500
                              </DropdownMenuItem>
                              <DropdownMenuItem
                                onClick={() => {
                                  setFieldValue(`apca_id`, "651966");
                                }}
                              >
                                BBL - 651966
                              </DropdownMenuItem>
                            </DropdownMenuContent>
                          </DropdownMenu>
                        </div>
                        <CustomLabelText
                          required={true}
                          labelText="APCA ID"
                          errorField={errors?.apca_id}
                        />
                      </Label>
                      <ReactInputMask
                        mask="999999"
                        id="apca_id"
                        name="apca_id"
                        value={values?.apca_id ? values?.apca_id : ""}
                        placeholder="APCA ID"
                        maskChar=""
                        onChange={(e) => {
                          setFieldValue(
                            `apca_id`,
                            e?.target?.value ? e?.target?.value : ""
                          );
                        }}
                        onBlur={(e) => {
                          setFieldValue(
                            `apca_id`,
                            e?.target?.value
                              ? padWithLeadingZeros(e?.target?.value, 6)
                              : ""
                          );
                        }}
                        className={
                          errors?.apca_id
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div> */}
                        {/* <div className="grid gap-2">
                      <Label htmlFor="opening_balance">
                        <CustomLabelText
                          required={false}
                          labelText="Opening Balance($)"
                          errorField={errors?.opening_balance}
                        />
                      </Label>

                      <NumericFormat
                        type="text"
                        name="opening_balance"
                        value={values?.opening_balance}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        decimalScale={2}
                        allowNegative={false}
                        thousandSeparator={true}
                        isAllowed={(values) => MaxLimit(values)}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.opening_balance
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div> */}
                      </div>
                    </div>
                  </div>
                </>
              )}
              {edit && (
                <div className="grid gap-4 pt-4">
                  <CardTitle className="text-md">
                    <div className="flex w-full items-center justify-between">
                      <div>Risk Assessment & Client Verification</div>
                      <div className="flex gap-2 items-center">
                        <Label>
                          <CustomLabelText
                            labelText="KYC"
                            errorField={errors?.is_kyc}
                          />
                        </Label>
                        <div className="flex items-center gap-4">
                          {vendorData?.kyc?.status && <Button>Reverify</Button>}
                          <Switch
                            name="is_kyc"
                            checked={values?.is_kyc}
                            onCheckedChange={(checked) =>
                              setFieldValue("is_kyc", checked)
                            }
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                  </CardTitle>
                  {values?.is_kyc && (
                    <>
                      <div className="grid md:grid-cols-4 gap-4">
                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="cdd">
                              <CustomLabelText
                                labelText="CDD Customer Type"
                                errorField={errors?.cdd_customer_type}
                              />
                            </Label>
                            <div className="relative mt-2">
                              <SearchSelect
                                frameworks={cddCustomerTypeOptions}
                                optionType={"CDD Customer Type"}
                                handleSelect={(e) => {
                                  setSectionType(
                                    `Onboarding-${e === "1" ? "Ongoing" : "Initial"}`,
                                  );
                                  setFieldValue("cdd_customer_type", e);
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.cdd_customer_type &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                disabled={
                                  edit && vendorData?.kyc?.status ? true : false
                                }
                                initialValue={values?.cdd_customer_type}
                              />
                            </div>
                          </div>
                        </div>

                        {values?.cdd_customer_type && (
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="risk_assessment_id">
                                <CustomLabelText
                                  labelText="Risk Assessment"
                                  errorField={errors?.risk_assessment_id}
                                />
                              </Label>
                              <div className="relative mt-2">
                                {values?.risk_assessment_id ? (
                                  <Button
                                    className="w-full justify-start h-9"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleViewAssessment();
                                    }}
                                  >
                                    <span className="flex gap-2 justify-start">
                                      <Eye size={18} />
                                      Risk Assessment
                                    </span>
                                  </Button>
                                ) : (
                                  <ResponsiveDrawerForm
                                    description={""}
                                    title={"Add Assessment"}
                                    handleOpen={() => {}}
                                    popupType={"risk-assessments"}
                                    handleClose={() => {
                                      setShowAssessment(false);
                                    }}
                                    buttonText={
                                      <div className="flex items-center gap-1">
                                        <LucidePlusCircle size={18} />
                                        <span>Conduct</span>
                                      </div>
                                    }
                                    className={"overflow-hidden"}
                                    open={showAssessment}
                                    buttonClassName={"w-full justify-start h-9"}
                                    setOpen={setShowAssessment}
                                    write={true}
                                  >
                                    <AddEditRiskAssessment
                                      edit={false}
                                      toggleShowAddEditRisk={toggleAssessment}
                                      id={""}
                                      sectionType={sectionType}
                                      organizationId={
                                        organizationData?.organizationId
                                      }
                                      customerName={
                                        formatName(
                                          values?.first_name,
                                          values?.last_name,
                                        ) +
                                        (values?.business_name
                                          ? ` (${values?.business_name})`
                                          : "")
                                      }
                                      setFieldValue={setFieldValue}
                                      fetchRiskData={() => {}}
                                    />
                                  </ResponsiveDrawerForm>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="risk">
                              <CustomLabelText
                                labelText="Risk Profile"
                                errorField={errors?.risk}
                              />
                            </Label>
                            <div className="relative mt-2">
                              <SearchSelect
                                frameworks={riskProfile}
                                optionType={"Risk Profile"}
                                handleSelect={(e) => {
                                  setFieldValue("risk", e);
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.risk &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                disabled={
                                  edit && vendorData?.kyc?.status ? true : false
                                }
                                initialValue={values?.risk}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="cdd">
                              <CustomLabelText
                                labelText="CDD Type"
                                errorField={errors?.cdd}
                              />
                            </Label>
                            <div className="relative mt-2">
                              <SearchSelect
                                frameworks={cddOptions}
                                optionType={"CDD Type"}
                                handleSelect={(e) => {
                                  setFieldValue("cdd", e);
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.cdd &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                disabled={
                                  edit && vendorData?.kyc?.status ? true : false
                                }
                                initialValue={values?.cdd}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {values?.cdd && values?.risk && (
                        <FieldArray name="verifications">
                          {({ push, remove }) => (
                            <div className="space-y-6">
                              {values.verifications?.map((row, index) => (
                                <VerificationRow
                                  key={index}
                                  index={index}
                                  values={values}
                                  push={push}
                                  errors={errors}
                                  remove={remove}
                                  verificationMethods={verificationMethods}
                                  verificationTypes={verificationTypes}
                                  userList={userList}
                                  setUserList={setUserList}
                                  mainData={vendorData}
                                  setUserLoading={setUserLoading}
                                  userLoading={userLoading}
                                  organizationData={organizationData}
                                  userListing={userListing}
                                />
                              ))}

                              {values.verifications?.length === 0 && (
                                <Button
                                  type="button"
                                  variant="outline"
                                  onClick={() =>
                                    push({
                                      method: "",
                                      type: "",
                                      document_number: "",
                                      verified_by: "",
                                      date_verified: "",
                                      verified: 0,
                                    })
                                  }
                                >
                                  VerifiyID
                                </Button>
                              )}
                            </div>
                          )}
                        </FieldArray>
                      )}

                      {values?.type === "2" && (
                        <>
                          <hr />
                          <FieldArray name="beneficiaries">
                            {({ push, remove }) => (
                              <div className="space-y-6">
                                {values?.beneficiaries?.map((row, index) => (
                                  <BeneficaryRow
                                    key={index}
                                    index={index}
                                    values={values}
                                    push={push}
                                    errors={errors}
                                    remove={remove}
                                  />
                                ))}

                                {values?.beneficiaries?.length === 0 && (
                                  <Button
                                    type="button"
                                    variant="outline"
                                    onClick={() =>
                                      push({
                                        name: "",
                                        percentage: "",
                                      })
                                    }
                                  >
                                    Add Beneficiaries
                                  </Button>
                                )}
                              </div>
                            )}
                          </FieldArray>
                        </>
                      )}

                      {values?.risk === "1" &&
                      !values?.compliance_manager_id ? (
                        <>
                          <hr />
                          <Button
                            className="w-fit"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleConfirmEscalated();
                            }}
                          >
                            <span className="flex gap-2 justify-start">
                              <MessageSquareShareIcon size={18} />
                              Escalate
                            </span>
                          </Button>
                        </>
                      ) : values?.compliance_manager_id ? (
                        <>
                          <div>
                            <p>
                              <b>Escalated To:</b>{" "}
                              {values?.compliance_manager_name}
                            </p>
                            <p>
                              <b>Reason:</b> {values?.reason}
                            </p>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      <div className="grid md:grid-cols-1 gap-4">
                        <div className="grid gap-2">
                          <Label htmlFor="notes">
                            <CustomLabelText
                              labelText="Note"
                              errorField={errors?.notes}
                            />
                          </Label>
                          <Textarea
                            name="notes"
                            rows={4}
                            placeholder="How did you verify Individual's Full Name AND Either Residential Address OR DOB? Or add reasoning/notes."
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.notes}
                            disabled={
                              edit && vendorData?.kyc?.status ? true : false
                            }
                          />
                        </div>
                      </div>
                      <div className="grid md:grid-cols-1 gap-4">
                        <div className="grid gap-2">
                          <Label htmlFor="ntf_note">
                            <CustomLabelText
                              labelText="Nature & Purpose of Transaction"
                              errorField={errors?.ntf_note}
                            />
                          </Label>
                          <Textarea
                            name="ntf_note"
                            rows={4}
                            placeholder="Write a note of Nature & Purpose of Transaction"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.ntf_note}
                            disabled={
                              edit && vendorData?.kyc?.status ? true : false
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}
              {!onlyKyc && (
                <div className="grid gap-4 pt-4">
                  <CardTitle className="text-md">Joint Account</CardTitle>
                  <FieldArray name="joint_accounts">
                    {({ push, remove }) => (
                      <div className="grid gap-6">
                        {values.joint_accounts?.map((item, index) => (
                          <div
                            key={index}
                            className="grid lg:grid-cols-4 grid-cols-2 gap-4 border rounded-xl p-4 relative"
                          >
                            <div className="grid gap-2">
                              <Label
                                htmlFor={`joint_accounts.${index}.first_name`}
                              >
                                <CustomLabelText
                                  required={false}
                                  labelText="First Name"
                                  errorField={
                                    errors?.joint_accounts?.[index]?.first_name
                                  }
                                />
                              </Label>
                              <Input
                                id={`joint_accounts.${index}.first_name`}
                                type="text"
                                name={`joint_accounts.${index}.first_name`}
                                value={
                                  values?.joint_accounts?.[index]?.first_name
                                    ? values?.joint_accounts?.[index]
                                        ?.first_name
                                    : ""
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.joint_accounts?.[index]?.first_name &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label
                                htmlFor={`joint_accounts.${index}.last_name`}
                              >
                                <CustomLabelText
                                  required={true}
                                  labelText="Last Name"
                                  errorField={
                                    errors?.joint_accounts?.[index]?.last_name
                                  }
                                />
                              </Label>
                              <Input
                                id={`joint_accounts.${index}.last_name`}
                                type="text"
                                name={`joint_accounts.${index}.last_name`}
                                value={
                                  values?.joint_accounts?.[index]?.last_name
                                    ? values?.joint_accounts?.[index]?.last_name
                                    : ""
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.joint_accounts?.[index]?.last_name &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor={`joint_accounts.${index}.dob`}>
                                  <CustomLabelText
                                    labelText="Date Of Birth"
                                    errorField={
                                      errors?.joint_accounts?.[index]?.dob
                                    }
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <DateInputPicker
                                    date={
                                      values?.joint_accounts?.[index]?.dob
                                        ? values?.joint_accounts?.[index]?.dob
                                        : ""
                                    }
                                    onSelect={(e) => {
                                      setFieldValue(
                                        `joint_accounts.${index}.dob`,
                                        e,
                                      );
                                    }}
                                    inputClassName="w-full"
                                    className={""}
                                    disabledDate={{ after: new Date() }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex gap-2 justify-end">
                              <div className="flex gap-2 items-center h-fit">
                                <Label>
                                  <CustomLabelText
                                    labelText="International Address"
                                    errorField={
                                      errors?.values?.joint_accounts?.[index]
                                        ?.international_address
                                    }
                                  />
                                </Label>
                                <Switch
                                  name={`joint_accounts.${index}.international_address`}
                                  checked={
                                    (values?.values?.joint_accounts?.[index]
                                      ?.international_address ||
                                      values?.joint_accounts?.[index]
                                        ?.international_address == "1") &&
                                    values?.joint_accounts?.[index]
                                      ?.international_address != "0"
                                      ? true
                                      : false
                                  }
                                  onCheckedChange={(checked) =>
                                    setFieldValue(
                                      `joint_accounts.${index}.international_address`,
                                      checked,
                                    )
                                  }
                                  onBlur={handleBlur}
                                />
                              </div>
                              {index + 1 === values?.joint_accounts?.length ? (
                                <>
                                  <Button
                                    type="button"
                                    className="h-fit w-fit p-1 "
                                    onClick={() => {
                                      push({
                                        first_name: "",
                                        last_name: "",
                                        dob: "",
                                        international_address: "",
                                        full_address: "",
                                        country_id: "",
                                        street: "",
                                        state_id: "",
                                        suburb_id: "",
                                        postal_code: "",
                                      });
                                      setSearched(false);
                                    }}
                                  >
                                    <Plus size={20} />
                                  </Button>{" "}
                                  {!values?.joint_accounts?.[index]
                                    ?.is_used && (
                                    <>
                                      <Button
                                        type="button"
                                        className="h-fit w-fit p-1 bg-red-500"
                                        onClick={() => remove(index)}
                                      >
                                        <Trash2 size={20} />
                                      </Button>
                                    </>
                                  )}
                                </>
                              ) : (
                                !values?.joint_accounts?.[index]?.is_used && (
                                  <>
                                    <Button
                                      type="button"
                                      className="h-fit w-fit p-1 bg-red-500"
                                      onClick={() => remove(index)}
                                    >
                                      <Trash2 size={20} />
                                    </Button>
                                  </>
                                )
                              )}
                            </div>
                            {(values?.joint_accounts?.[index]
                              ?.international_address ||
                              values?.joint_accounts?.[index]
                                ?.international_address == "1") &&
                            values?.joint_accounts?.[index]
                              ?.international_address != "0" ? (
                              <>
                                <div className="grid gap-1 col-span-3">
                                  <Label
                                    htmlFor={`joint_accounts.${index}.full_address`}
                                  >
                                    <CustomLabelText
                                      required={false}
                                      labelText="Full Address"
                                      errorField={
                                        errors?.joint_accounts?.[index]
                                          ?.full_address
                                      }
                                    />
                                  </Label>
                                  <Input
                                    id={`joint_accounts.${index}.full_address`}
                                    placeholder="Enter Address"
                                    required
                                    name={`joint_accounts.${index}.full_address`}
                                    onChange={(e) => {
                                      setFieldValue(
                                        `joint_accounts.${index}.full_address`,
                                        e?.target?.value,
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    value={
                                      values?.joint_accounts?.[index]
                                        ?.full_address
                                    }
                                    className={
                                      errors?.joint_accounts?.[index]
                                        ?.full_address &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                  />
                                </div>
                                <div className="grid gap-2">
                                  <div className="min-w-0">
                                    <Label
                                      htmlFor={`joint_accounts.${index}.country_id`}
                                    >
                                      <CustomLabelText
                                        required={false}
                                        labelText="Country"
                                        errorField={
                                          errors?.joint_accounts?.[index]
                                            ?.country_id
                                        }
                                      />
                                    </Label>
                                    <div className="relative mt-2">
                                      <SearchSelect
                                        frameworks={countryListing}
                                        itemsPerPage={300}
                                        optionType={"Country"}
                                        clearable={true}
                                        onClear={() => {
                                          setFieldValue(
                                            `joint_accounts.${index}.country_id`,
                                            "",
                                          );
                                        }}
                                        handleSelect={(e) => {
                                          setFieldValue(
                                            `joint_accounts.${index}.country_id`,
                                            e,
                                          );
                                        }}
                                        handleBlur={handleBlur}
                                        className={
                                          errors?.joint_accounts?.[index]
                                            ?.country_id &&
                                          `focus-visible:ring-red-500 border-red-500`
                                        }
                                        disabled={false}
                                        initialValue={
                                          values?.joint_accounts?.[index]
                                            ?.country_id
                                        }
                                      />
                                      {countryLoading && (
                                        <span className="absolute top-2 right-2 animate-spin">
                                          <Loader2 width={20} height={20} />
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="grid gap-1">
                                  <Label
                                    htmlFor={`joint_accounts.${index}.street`}
                                  >
                                    <CustomLabelText
                                      required={false}
                                      labelText="Street Address"
                                      errorField={
                                        errors?.joint_accounts?.[index]?.street
                                      }
                                    />
                                  </Label>
                                  <Input
                                    id={`joint_accounts.${index}.street`}
                                    placeholder="Enter Street"
                                    required
                                    name={`joint_accounts.${index}.street`}
                                    onChange={(e) => {
                                      setFieldValue(
                                        `joint_accounts.${index}.street`,
                                        e?.target?.value,
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    value={
                                      values?.joint_accounts?.[index]?.street
                                    }
                                    className={
                                      errors?.joint_accounts?.[index]?.street &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                  />
                                </div>
                                <div className="grid gap-2">
                                  <div className="min-w-0">
                                    <Label
                                      htmlFor={`joint_accounts.${index}.state_id`}
                                    >
                                      <CustomLabelText
                                        required={false}
                                        labelText="State"
                                        errorField={
                                          errors?.joint_accounts?.[index]
                                            ?.state_id
                                        }
                                      />
                                    </Label>
                                    <div className="relative mt-2">
                                      <SearchSelect
                                        frameworks={stateListing}
                                        optionType={"State"}
                                        handleSelect={(e) => {
                                          setFieldValue(
                                            `joint_accounts.${index}.state_id`,
                                            e,
                                          );
                                          setFieldValue(
                                            `joint_accounts.${index}.suburb_id`,
                                            "",
                                          );
                                        }}
                                        handleBlur={handleBlur}
                                        className={
                                          errors?.joint_accounts?.[index]
                                            ?.state_id &&
                                          `focus-visible:ring-red-500 border-red-500`
                                        }
                                        disabled={false}
                                        initialValue={
                                          values?.joint_accounts?.[index]
                                            ?.state_id
                                        }
                                      />
                                      {stateLoading && (
                                        <span className="absolute top-2 right-2 animate-spin">
                                          <Loader2 width={20} height={20} />
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="grid gap-2">
                                  <div className="min-w-0">
                                    <Label
                                      htmlFor={`joint_accounts.${index}.suburb_id`}
                                    >
                                      <CustomLabelText
                                        required={false}
                                        labelText="Suburb"
                                        errorField={
                                          errors?.joint_accounts?.[index]
                                            ?.suburb_id
                                        }
                                      />
                                    </Label>

                                    <div className="relative mt-2">
                                      <SearchSelect
                                        frameworks={allSuburbListing?.filter(
                                          (item) =>
                                            item.state_id ===
                                            values?.joint_accounts?.[index]
                                              ?.state_id,
                                        )}
                                        optionType={"Suburb"}
                                        handleSelect={(e) => {
                                          setFieldValue(
                                            `joint_accounts.${index}.suburb_id`,
                                            e,
                                          );
                                          searched && setSearched(false);
                                        }}
                                        itemsPerPage={100}
                                        handleSearch={(e) => {
                                          if (e) {
                                            setSearched(true);
                                            handleSearchAllSuburb(e);
                                          } else {
                                            setSearched(false);

                                            FetchAllSuburbList();
                                          }
                                        }}
                                        handleBlur={handleBlur}
                                        className={
                                          errors?.joint_accounts?.[index]
                                            ?.suburb_id &&
                                          `focus-visible:ring-red-500 border-red-500`
                                        }
                                        disabled={
                                          !values?.joint_accounts?.[index]
                                            ?.state_id
                                        }
                                        initialValue={
                                          values?.joint_accounts?.[index]
                                            ?.suburb_id
                                        }
                                      />
                                      {allSuburbLoading && (
                                        <span className="absolute top-2 right-2 animate-spin">
                                          <Loader2 width={20} height={20} />
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="grid gap-2">
                                  <Label
                                    htmlFor={`joint_accounts.${index}.postal_code`}
                                  >
                                    <CustomLabelText
                                      required={false}
                                      labelText="Postal Code"
                                      errorField={
                                        errors?.joint_accounts?.[index]
                                          ?.postal_code
                                      }
                                    />
                                  </Label>
                                  <PostalCodeInput
                                    id={`joint_accounts.${index}.postal_code`}
                                    placeholder="Enter Postal Code"
                                    required={false}
                                    name={`joint_accounts.${index}.postal_code`}
                                    handleChange={(e) => {
                                      setFieldValue(
                                        `joint_accounts.${index}.postal_code`,
                                        e,
                                      );
                                    }}
                                    handleBlur={handleBlur}
                                    className="justify-start"
                                    inputClassName={
                                      errors?.joint_accounts?.[index]
                                        ?.postal_code &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    value={
                                      values?.joint_accounts?.[index]
                                        ?.postal_code
                                        ? values?.joint_accounts?.[index]
                                            ?.postal_code
                                        : ""
                                    }
                                  />
                                </div>
                              </>
                            )}

                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label
                                  htmlFor={`joint_accounts.${index}.bank_id`}
                                >
                                  <CustomLabelText
                                    required={false}
                                    labelText="Bank Name"
                                    errorField={
                                      errors?.joint_accounts?.[index]?.bank_id
                                    }
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    frameworks={bankListing}
                                    optionType={"Bank"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `joint_accounts.${index}.bank_id`,
                                        e,
                                      );
                                    }}
                                    clearable={true}
                                    onClear={() => {
                                      setFieldValue(
                                        `joint_accounts.${index}.bank_id`,
                                        "",
                                      );
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.joint_accounts?.[index]
                                        ?.bank_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={false}
                                    initialValue={
                                      values?.joint_accounts?.[index]?.bank_id
                                    }
                                  />
                                  {bankLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="grid gap-2">
                              <Label
                                htmlFor={`joint_accounts.${index}.account_name`}
                              >
                                <CustomLabelText
                                  required={false}
                                  labelText="Bank Account Name"
                                  errorField={
                                    errors?.joint_accounts?.[index]
                                      ?.account_name
                                  }
                                />
                              </Label>
                              <Input
                                type="text"
                                name={`joint_accounts.${index}.account_name`}
                                value={
                                  values?.joint_accounts?.[index]?.account_name
                                    ? values?.joint_accounts?.[index]
                                        ?.account_name
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue(
                                    `joint_accounts.${index}.account_name`,
                                    e?.target?.value,
                                  );
                                }}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.joint_accounts?.[index]
                                    ?.account_name &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor={`joint_accounts.${index}.bsb`}>
                                <CustomLabelText
                                  required={false}
                                  labelText="BSB"
                                  errorField={
                                    errors?.joint_accounts?.[index]?.bsb
                                  }
                                />
                              </Label>
                              <ReactInputMask
                                id={`joint_accounts.${index}.bsb`}
                                type="text"
                                name={`joint_accounts.${index}.bsb`}
                                value={
                                  values?.joint_accounts?.[index]?.bsb
                                    ? values?.joint_accounts?.[index]?.bsb
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue(
                                    `joint_accounts.${index}.bsb`,
                                    e?.target?.value,
                                  );
                                }}
                                onBlur={handleBlur}
                                mask="999-999"
                                maskChar={null}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.joint_accounts?.[index]?.bsb
                                    ? `${cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )} focus-visible:ring-red-500 border-red-500`
                                    : cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )
                                }
                              />
                            </div>
                            <div className="grid gap-2">
                              <Label
                                htmlFor={`joint_accounts.${index}.account_number`}
                              >
                                <CustomLabelText
                                  required={false}
                                  labelText="Account Number"
                                  errorField={
                                    errors?.joint_accounts?.[index]
                                      ?.account_number
                                  }
                                />
                              </Label>
                              <ReactInputMask
                                id={`joint_accounts.${index}.account_number`}
                                type="text"
                                name={`joint_accounts.${index}.account_number`}
                                value={
                                  values?.joint_accounts?.[index]
                                    ?.account_number
                                    ? values?.joint_accounts?.[index]
                                        ?.account_number
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue(
                                    `joint_accounts.${index}.account_number`,
                                    e?.target?.value,
                                  );
                                }}
                                onBlur={handleBlur}
                                mask="999999999"
                                maskChar={null}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.joint_accounts?.[index]
                                    ?.account_number
                                    ? `${cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )} focus-visible:ring-red-500 border-red-500`
                                    : cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )
                                }
                              />
                            </div>
                          </div>
                        ))}
                        {values?.joint_accounts?.length === 0 && (
                          <Button
                            type="button"
                            // variant="secondary"
                            onClick={() =>
                              push({
                                first_name: "",
                                last_name: "",
                                dob: "",
                                street: "",
                                state_id: "",
                                suburb_id: "",
                                postal_code: "",
                              })
                            }
                          >
                            + Add Joint Account
                          </Button>
                        )}
                      </div>
                    )}
                  </FieldArray>
                </div>
              )}
            </div>

            {viewAssessment && (
              <RiskAssessmentDetailsPopup
                showView={viewAssessment}
                id={values?.risk_assessment_id}
                toggleShowModal={toggleViewAssessment}
                setShowView={setViewAssessment}
                sectionType={sectionType}
              />
            )}

            {confirmEscalated && (
              <ResponsiveDrawerForm
                description={""}
                title={`Escalated`}
                handleOpen={() => {}}
                handleClose={() => {
                  toggleConfirmEscalated();
                }}
                popupType={"cdds"}
                write={true}
                buttonText={""}
                open={confirmEscalated}
                buttonClassName={""}
                setOpen={setConfirmEscalated}
                className={"sm:max-w-3xl"}
              >
                <EscalatedModal
                  data={{
                    id: vendorData?.kyc?.id ? vendorData?.kyc?.id : "",
                    compliance_manager_id: values?.compliance_manager_id,
                    reason: values?.reason,
                  }}
                  toggleConfirmEscalated={toggleConfirmEscalated}
                  fetchData={() => {}}
                  setFieldValue={setFieldValue}
                />
              </ResponsiveDrawerForm>
            )}

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditVendor();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditVendor;
